import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=29996bac&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"
import style0 from "./Contact.vue?vue&type=style&index=0&id=29996bac&prod&scoped=true&lang=scss"
import style1 from "./Contact.vue?vue&type=style&index=1&id=29996bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29996bac",
  null
  
)

export default component.exports